import AttributeValue from "./AttributeValue"

/**
 * Reperesents AttributeTypes of the AttributeColorValue.
 *
 * @see attribute_values property of the AttributeInterface from expivi
 */
export default class AttributeColorValue extends AttributeValue {
    constructor(data) {
        super(data)
    }

    getColorOptions() {
        return this.get('valuable.colors', [])
    }

    hasColorOptions() {
        return this.has('valuable.colors')
    }
}
